const getPageLocale = require("../localization/getPageLocale");

/**
 * @param localeField {HTMLInputElement}
 * @return {void}
 */
module.exports = function initLocaleField(localeField) {
    localeField.value = getPageLocale();
}